/* ============================================================================
   Velocity PDP behaviour — gallery, variants, qty, cart AJAX, same-day
   countdown, mix calculator, FAQ accordion, product recommendations.
   INP-friendly: event delegation, passive listeners, rAF, no per-node binds.
   ============================================================================ */
(function () {
  var root = document.querySelector('.vpdp');
  if (!root) return;
  var CFG = window.AFX_PDP || { cutoffHour: 15, cutoffTz: 'America/Los_Angeles', ratio: '2:1', cartUrl: '/cart' };
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $all = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* ---- gallery ---- */
  var main = $('[data-gallery-main]');
  if (main) {
    var imgs = $all('img.gmain', main);
    if (imgs.length) imgs[0].classList.add('is-on');
    var thumbs = $('[data-gallery-thumbs]');
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-idx]'); if (!b) return;
      var i = b.getAttribute('data-idx');
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-idx') === i); });
      $all('[data-idx]', thumbs).forEach(function (t) { t.classList.toggle('is-on', t === b); });
    }, { passive: true });
  }

  /* ---- variant selection ---- */
  var input = $('[data-variant-input]');
  root.addEventListener('click', function (e) {
    var v = e.target.closest('[data-variant]'); if (!v) return;
    if (v.getAttribute('data-soldout')) return;
    var id = v.getAttribute('data-id'), price = v.getAttribute('data-price');
    if (input) input.value = id;
    $all('[data-variant]').forEach(function (b) { b.classList.toggle('is-on', b === v); });
    $all('[data-price]').forEach(function (p) { p.textContent = price; });
    var terms = $('shopify-payment-terms'); if (terms) terms.setAttribute('variant-id', id);
    try { history.replaceState({}, '', '?variant=' + id); } catch (err) {}
  });

  /* ---- quantity ---- */
  var qty = $('[data-qty]');
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-qty-inc]')) qty.value = (parseInt(qty.value, 10) || 1) + 1;
    if (e.target.closest('[data-qty-dec]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
  });

  /* ---- add to cart (AJAX) ---- */
  function broadcastCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('product-form:cart:update', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
  }
  var addInFlight = false;
  var form = $('#vpdp-form');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-add]', form); if (btn && btn.disabled) return;
    if (addInFlight) return;
    addInFlight = true; if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: input.value, quantity: parseInt(qty.value, 10) || 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast((res.d && res.d.description) || 'Could not add — check stock.'); return; }
        toast(res.d.product_title ? res.d.product_title + ' — added' : 'Added to cart');
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).then(broadcastCart).catch(function () {});
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      })
      .catch(function () { toast('That didn’t take. Try again, or text us.'); })
      .then(function () { addInFlight = false; if (btn) btn.disabled = false; });
  });

  /* ---- same-day ship countdown ---- */
  var cd = $('[data-countdown]'), cl = $('[data-cutoff-label]');
  function ptNow() { var p = {}; try { new Intl.DateTimeFormat('en-US', { timeZone: CFG.cutoffTz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); } catch (e) { var d = new Date(); p.hour = d.getHours(); p.minute = d.getMinutes(); p.second = d.getSeconds(); } return p; }
  function tick() {
    if (!cd) return;
    var p = ptNow(); var hh = +p.hour; if (hh === 24) hh = 0;
    var sec = hh * 3600 + (+p.minute) * 60 + (+p.second), cut = CFG.cutoffHour * 3600;
    var rem, today;
    if (sec < cut) { rem = cut - sec; today = true; } else { rem = (86400 - sec) + cut; today = false; }
    var h = Math.floor(rem / 3600), m = Math.floor((rem % 3600) / 60), s = rem % 60, pad = function (n) { return (n < 10 ? '0' : '') + n; };
    cd.textContent = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    if (cl) cl.textContent = today ? 'ships today' : 'ships next business day';
  }
  if (cd) { tick(); setInterval(tick, 1000); }

  /* ---- mix calculator ---- */
  var mc = $('[data-mixcalc]');
  if (mc) {
    var parts = String(CFG.ratio || '2:1').split(':').map(Number);
    var rc = parts[0] || 2, rh = parts[1] || 1;
    var clear = 5, reducer = false;
    function r1(n) { return Math.round(n * 10) / 10; }
    function paint() {
      var hard = r1(clear * rh / rc), red = reducer ? r1((clear + hard) * 0.1) : 0, ready = r1(clear + hard + red);
      $all('[data-mix-clear]', mc).forEach(function (e) { e.textContent = clear; });
      var hv = $('[data-mix-hardener]', mc); if (hv) hv.textContent = hard + ' L';
      var rv = $('[data-mix-reducer-val]', mc); if (rv) rv.textContent = red + ' L';
      var row = $('[data-mix-reducer-row]', mc); if (row) row.hidden = !reducer;
      var ready_el = $('[data-mix-ready]', mc); if (ready_el) ready_el.textContent = ready + ' L';
    }
    mc.addEventListener('click', function (e) {
      if (e.target.closest('[data-mix-inc]')) { clear = r1(clear + 0.5); paint(); }
      if (e.target.closest('[data-mix-dec]')) { clear = Math.max(0.5, r1(clear - 0.5)); paint(); }
    });
    var rx = $('[data-mix-reducer]', mc); if (rx) rx.addEventListener('change', function () { reducer = rx.checked; paint(); });
    paint();
  }

  /* ---- FAQ accordion ---- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-faq]'); if (!b) return;
    var ans = b.nextElementSibling, icon = $('[data-faq-icon]', b);
    var open = ans.classList.toggle('is-open');
    if (icon) icon.textContent = open ? '−' : '+';
  });

  /* ---- Overview read-more (only clamp when the content actually overflows) ---- */
  var ov = $('[data-overview]'), ovBody = $('[data-overview-body]'), ovToggle = $('[data-overview-toggle]');
  if (ov && ovBody && ovToggle) {
    var clampPx = 264;
    if (ovBody.scrollHeight <= clampPx + 24) {
      ov.classList.remove('is-clamped');     // short description — no toggle needed
      ovToggle.hidden = true;
    }
    ovToggle.addEventListener('click', function () {
      var open = ov.classList.toggle('is-open');
      ov.classList.toggle('is-clamped', !open);
      ovToggle.setAttribute('aria-expanded', String(open));
      ovToggle.firstChild.nodeValue = open ? 'Read less ' : 'Read more ';
    });
  }

  /* ---- product recommendations (Section Rendering API) ---- */
  var rec = $('[data-recommendations]');
  if (rec && rec.dataset.url && rec.children.length === 0) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) rec.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---- section nav active state ---- */
  var navLinks = $all('.vpdp-nav a');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        navLinks.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    ['vpdp-overview', 'vpdp-specs', 'vpdp-mix', 'vpdp-cure', 'vpdp-faq'].forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
  }

  /* ---- toast ---- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.style.cssText = 'position:fixed;left:50%;bottom:30px;transform:translateX(-50%);z-index:80;padding:12px 19px;background:#16110F;color:#fff;font-family:Archivo,sans-serif;font-size:13.5px;font-weight:600;border-radius:4px;'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.style.display = 'block';
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.style.display = 'none'; }, 2200);
  }
})();
